<script lang="ts">
    import { get } from "svelte/store";
    import { LL } from "../../../i18n/i18n-svelte";
    import { mediaSettingsOpenStore } from "../../Stores/MenuStore";
    import { usedMicrophoneDeviceIdStore } from "../../Stores/MediaStore";
    import { microphoneValidatedForDeviceIdStore } from "../../Stores/MicrophoneValidatedForDeviceIdStore";
    import { toastStore } from "../../Stores/ToastStoreSingleton";
    import Button from "../UI/Button.svelte";
    import ToastContainer from "./ToastContainer.svelte";

    interface Props {
        toastUuid: string;
    }

    let { toastUuid }: Props = $props();

    function handleOpenSettings(): void {
        mediaSettingsOpenStore.set(true);
        closeToast();
    }

    function closeToast(): void {
        microphoneValidatedForDeviceIdStore.set(get(usedMicrophoneDeviceIdStore));
        // Remove toast on next tick so the store update is flushed and the settings panel can open first
        setTimeout(() => {
            toastStore.removeToast(toastUuid);
        }, 0);
    }
</script>

<ToastContainer extraClasses="w-full min-w-72 max-w-sm sm:min-w-80 sm:max-w-md" theme="error" {toastUuid}>
    <div class="flex flex-col gap-2">
        <p class="m-0 text-sm leading-snug text-white text-center">
            {$LL.actionbar.microphone.noSoundWarning()}
        </p>
    </div>
    {#snippet buttons()}
        <Button
            appearance="ghost"
            size="sm"
            class="flex-1"
            dataTestId="no-microphone-sound-ignore"
            onclick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                closeToast();
            }}
        >
            {$LL.actionbar.microphone.ignore()}
        </Button>
        <Button
            type="button"
            variant="danger"
            size="sm"
            class="flex-1"
            dataTestId="no-microphone-sound-open-settings"
            onclick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                handleOpenSettings();
            }}
        >
            {$LL.actionbar.microphone.openSettings()}
        </Button>
    {/snippet}
</ToastContainer>
